import React from 'react'


import '../../HomePages/assets/HomePage.css'
import '../../../pages/asstes/still.css'

const HomeFooter = () => {
  return (
    <div className='HomeFooterContainer'>
        <ul>
            <li>Anasayfa</li>
            <li>Hakkımızda</li>
            <li>S.S.S</li>
            <li>iletişim</li>
        </ul>
        <p>© 2025 - 2026 Hikmetin İzinde. Built with Önder. All rights reserved.</p>
    </div>
  )
}

export default HomeFooter